<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance " id="resubscribe_with_pin">
      <div class="modal__content">
        <div class="modal__body">
<!--          <div class="logo_form"><img :src="getTranslations.logo_for_branded_projects || 'static/images/Swipo_logo_02.png'" alt=""></div>-->
          <h1>{{ getTranslations.home_modals_loading_please_wait }}</h1>

          <div class="loader-contv1">
            <div class="loader-cont__wrapperv1">
              <div class="loaderv1"></div>

            </div>
          </div>

        </div>
        <div class="modal__footer">
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'loading',
  created() {
    this.showModal();
  },
  methods: {
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(function () {
          vm.$emit('close');
          $('#loading').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'integrationHeader',
      'availableIntegrations',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/Loading.vue